import type {MessageAttachment} from '@microsoft/agent-host-protocol'
import {ssrSafeLocation} from '@github-ui/ssr-utils'

function repoMatches(repo: unknown, scopeOwner: string | null): boolean {
  return Boolean(
    scopeOwner &&
    repo &&
    typeof repo === 'object' &&
    'owner' in repo &&
    typeof repo.owner === 'string' &&
    repo.owner.toLowerCase() === scopeOwner.toLowerCase(),
  )
}

export function isAttachmentInScope(attachment: MessageAttachment, scopeOwner: string | null | undefined): boolean {
  if (scopeOwner === undefined) return true
  const detail: unknown = attachment._meta?.['copilot.attachmentDetail']
  if (!detail || typeof detail !== 'object') {
    return !['repository', 'github-file', 'github-snippet', 'github-file-diff'].includes(attachment.displayKind ?? '')
  }
  if ('repo' in detail) return repoMatches(detail.repo, scopeOwner)
  if (!('type' in detail)) return true
  if (detail.type === 'github_file_diff') {
    const sides = ['base' in detail ? detail.base : null, 'head' in detail ? detail.head : null].filter(Boolean)
    return (
      sides.length > 0 &&
      sides.every(side => side && typeof side === 'object' && 'repo' in side && repoMatches(side.repo, scopeOwner))
    )
  }
  if (['github_file', 'github_repository', 'github_snippet'].includes(String(detail.type))) return false
  if (detail.type === 'github_reference') {
    if (!scopeOwner || !('url' in detail) || typeof detail.url !== 'string') return false
    try {
      const url = new URL(detail.url, ssrSafeLocation.origin || 'https://github.com')
      return (
        ['http:', 'https:'].includes(url.protocol) &&
        url.pathname.split('/')[1]?.toLowerCase() === scopeOwner.toLowerCase()
      )
    } catch {
      return false
    }
  }
  return true
}
